import { FileRoutesByFullPath } from '@/routeTree.gen';

export const routes = {
  root: '/',
  patients: '/patients',
  procedures: '/procedures',
  procedureDetails: '/procedures/$procedureId',
  patientDetails: '/patients/$patientId',
  subjectDetails: '/subjects/$subjectId',
  assessmentForm: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire',
  assessmentFormResponse: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response',
  procedureCueingResponse: '/patients/$patientId/procedures/$procedureId/cueing',
  sites: '/sites',
  siteDetails: '/sites/$siteId',
  consents: '/consents',
  consentDetails: '/consents/$templateId',
  login: '/login',
  firstTimeLogin: '/first-time-login',
  setNewPassword: '/set-new-password',
  passwordSet: '/password-set',
  forgotPassword: '/forgot-password',
  codeSent: '/code-sent',
  resetPassword: '/reset-password',
  passwordUpdated: '/password-updated',
  setupMfa: '/setup-mfa',
  mfa: '/mfa',
  verify: '/verify',
  cockpitOverview: '/cockpit/$procedureId/overview',
  cockpitTreatment: '/cockpit/$procedureId/treatment',
} as const satisfies Record<string, keyof FileRoutesByFullPath>;

// Extract params from a single route pattern
type ExtractParams<S extends string> =
  string extends S
    ? never
    : S extends `${string}$${infer Param}/${infer Rest}`
      ? Param | ExtractParams<`/${Rest}`>
      : S extends `${string}$${infer Param}`
        ? Param
        : never;

// Map route key -> its param object
export type RouteParams<K extends keyof typeof routes> =
  ExtractParams<(typeof routes)[K]> extends never
    ? Record<string, never>
    : Record<ExtractParams<(typeof routes)[K]>, string>;

export function assembleRoute<T extends keyof typeof routes>(
  route: T,
  ...[ params ]: RouteParams<T> extends Record<string, never>
    ? [params?: RouteParams<T>]
    : [params: RouteParams<T>]
): string {
  let path: string = routes[route];
  if (!params) return path;

  (Object.entries(params) as [string, string][])
    .forEach(([ k, v ]) => {
      path = path.replace(`$${k}`, encodeURIComponent(v));
    });

  return path;
}
